import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Upload from './upload'
import List from './list'
function App() {
  return (

    <BrowserRouter>
    <div> 
    <Routes>
    <Route>
    <Route path="/" element={<List />} />
    <Route path="/upload" element={<  Upload />} />
    </Route>
    </Routes>
    </div>
    </BrowserRouter>
    
   
  );
}

export default App;
